export default [
    {
        path: '/',
        name: 'login',
        component: () => import('@/views/pages/authentication/Login.vue'),
        meta: {
          layout: 'full',
          redirectIfLoggedIn: true,
        },
      },
      {
        path: '/forgot-password',
        name: 'forgot-password',
        component: () => import('@/views/pages/authentication/ForgotPassword.vue'),
        meta: {
          layout: 'full',
          redirectIfLoggedIn: true,
        },
      },
      {
        path: '/reset-password',
        name: 'reset-password',
        component: () => import('@/views/pages/authentication/ResetPassword.vue'),
        meta: {
          layout: 'full',
          redirectIfLoggedIn: true,
        },
      },
  ]
  